"use client";

import { useEffect, useRef } from "react";
import Link from "next/link";
import AppImage from "@/components/ui/AppImage";

export default function CtaBandSection() {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const els = ref?.current?.querySelectorAll(".reveal");
        if (!els) return;
        const observer = new IntersectionObserver(
            (entries) =>
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        e.target.classList.add("visible");
                        observer.unobserve(e.target);
                    }
                }),
            { threshold: 0.15 }
        );
        els?.forEach((el) => observer?.observe(el));
        return () => observer?.disconnect();
    }, []);

    return (
        <section
            ref={ref}
            className="relative overflow-hidden"
            style={{ padding: "120px 0" }}
            aria-label="Partnership call to action">

            {/* Background image */}
            <div className="absolute inset-0 z-0">
                <AppImage
                    src="https://img.rocket.new/generatedImages/rocket_gen_img_181b8384a-1767159580913.png"
                    alt="Aerial view of industrial port with cargo vessels and bulk material handling"
                    fill
                    className="object-cover" />

                <div
                    className="absolute inset-0"
                    style={{
                        background:
                            "linear-gradient(135deg, rgba(14,26,43,0.95) 0%, rgba(14,26,43,0.82) 100%)"
                    }} />

            </div>

            <div
                className="relative z-10 px-6 lg:px-12 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-12"
                style={{ maxWidth: "1280px", margin: "0 auto" }}>

                {/* Left */}
                <div className="flex flex-col gap-6 max-w-xl">
                    <span className="type-subheading reveal" style={{ color: "var(--color-red)" }}>
                        Partner With Us
                    </span>
                    <h2
                        className="reveal reveal-delay-1"
                        style={{
                            fontFamily: "var(--font-serif)",
                            fontSize: "clamp(2rem, 3.5vw, 3rem)",
                            fontWeight: 400,
                            color: "var(--color-white)",
                            lineHeight: 1.1,
                            letterSpacing: "-0.02em"
                        }}>

                        Ready to secure your
                        <br />
                        antimony supply chain?
                    </h2>
                    <p
                        className="reveal reveal-delay-2"
                        style={{
                            fontFamily: "var(--font-sans)",
                            fontSize: "1rem",
                            color: "rgba(255,255,255,0.6)",
                            lineHeight: "1.7"
                        }}>

                        Our commercial team responds to all enquiries within one business day.
                        <br />
                        We engage with procurement managers, trading desks, and C-suite
                        representatives on equal terms.
                    </p>
                </div>

                {/* Right — contact card */}
                <div
                    className="reveal reveal-delay-3 flex flex-col gap-6"
                    style={{
                        background: "var(--color-navy-mid)",
                        border: "1px solid rgba(255,255,255,0.3)",
                        borderRadius: "4px",
                        padding: "40px",
                        minWidth: "320px"
                    }}>

                    <p
                        style={{
                            fontFamily: "var(--font-sans)",
                            fontSize: "0.75rem",
                            fontWeight: 600,
                            letterSpacing: "0.1em",
                            textTransform: "uppercase",
                            color: "rgba(255,255,255,0.35)"
                        }}>

                        Commercial Enquiries
                    </p>
                    <div className="flex flex-col gap-3">
                        <p
                            style={{
                                fontFamily: "var(--font-sans)",
                                fontSize: "0.9375rem",
                                color: "rgba(255,255,255,0.75)"
                            }}>

                            info@gfs-apac.com
                        </p>
                        <p
                            style={{
                                fontFamily: "var(--font-sans)",
                                fontSize: "0.9375rem",
                                color: "rgba(255,255,255,0.75)"
                            }}>

                            +66 61 113 3442
                        </p>
                    </div>
                    <div className="flex flex-col gap-3 pt-2">
                        <Link href="/contact" className="btn-primary" style={{ justifyContent: "center" }}>
                            Request Proposal
                        </Link>
                        <Link
                            href="/operations"
                            className="btn-secondary"
                            style={{ justifyContent: "center" }}>

                            View Operations
                        </Link>
                    </div>
                </div>
            </div>
        </section>);

}